import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AddNewReviewCommentComponent} from './add-new-review-comment/add-new-review-comment.component';
import {Product} from '../../../../models/product';
import {ReviewsService} from '../../../../services/reviews.service';
import {response} from 'express';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-product-reviews',
  templateUrl: './product-reviews.component.html',
  styleUrls: ['./product-reviews.component.css']
})
export class ProductReviewsComponent implements OnInit{

  @Input() product: Product;
  @Output() reviews_count  = new EventEmitter<number>();

  reviews;

  newCommentAddedEvent;
  constructor(private dialog: MatDialog , private reviewService: ReviewsService) {

    this.newCommentAddedEvent = this.reviewService.AddNewCommentEvent$.subscribe(response => {
      this.loadReviews();
    })


  }

  ngOnInit() {
    this.loadReviews();

  }

  loadReviews(){

    let obj = {
      store_id : environment.store_id,
      product_id: this.product.id
    }

    this.reviewService.getReviewsList(obj).subscribe(response => {
      this.reviews = response

      this.reviews_count.emit(this.reviews.length);

    })

  }


  openNewReviewCommentDialog(){
    this.dialog.open(AddNewReviewCommentComponent , {
      width : '750px',
      data : {parent : this , product : this.product}
    })

  }

}
